import { CONNECTED_APP_COUNT } from "@/lib/integration-count";

// Single source of truth for the homepage FAQ copy. `faq.tsx` renders the
// visible accordion from this array, and `page.tsx` builds the FAQPage
// JSON-LD `mainEntity` from the same array, so the two can't drift.
export const FAQ_ITEMS: { q: string; a: string }[] = [
  {
    q: "What exactly is an AI agent?",
    a: "An AI agent is like a virtual employee. It's a software program that can complete real tasks — draft emails, update your CRM, write social posts, build reports — around the clock, with anything customer-facing held for your approval. Unlike a chatbot, it doesn't just answer questions. It does work.",
  },
  {
    q: "Do I need technical skills to use Raileon?",
    a: 'Not at all — no coding required. You describe what you need in plain English — like briefing a new hire. "Follow up with every new lead." "Send me a weekly sales report." You connect your own accounts, and we walk you through every step.',
  },
  {
    q: "How is this different from ChatGPT?",
    a: "ChatGPT is a general-purpose chatbot. Raileon gives you a fully managed AI operations layer — agents configured with your documents and preferences, connected to your tools, working around the clock and holding anything customer-facing for your approval. You're not typing prompts. Your agents are completing real tasks for you.",
  },
  {
    q: "How does setup work?",
    a: "It starts with a free audit call, where we learn how your business runs, your tools, and your goals. From that we write you a custom proposal. Once you sign, your Raileon team sets up your workspace, your agents, and your connections for you, and we email you the moment your workspace is live. We agree a schedule with you once we know how much we're setting up.",
  },
  {
    q: "Is my business data secure?",
    a: "Absolutely. Every client gets a dedicated, isolated instance, encrypted in transit and at rest. Your data never trains public AI models. We manage all security updates, monitoring, and backups for you.",
  },
  {
    q: "What happens if my AI agent makes a mistake?",
    a: "Your Raileon team sets approval rules with you for sensitive tasks — your agent drafts it, you approve it before it goes out, and anything that spends money is confirmed with you by your team first. For routine tasks, agents learn from your corrections and improve over time. A human is always in the loop for anything sensitive.",
  },
  // COUNSEL-REVIEW: summarises cancellation terms; keep in step with
  // /terms §6 and /refunds §1 (F5b).
  {
    q: "How do I cancel?",
    a: "Email your Raileon account team at admin@raileon.com, as set out in your service agreement. There's no penalty or exit fee — cancellation takes effect at the end of your current billing period, and periods already paid for aren't refunded. Your data is always yours: you get a full export window if you decide to leave. Full details on our Cancellation & Refunds page.",
  },
  {
    q: "What tools does Raileon integrate with?",
    a: `Gmail, HubSpot, Slack, Calendly, Stripe, QuickBooks, and more — ${CONNECTED_APP_COUNT} apps you can connect, and growing. Your agents can act on some today and others are connect-only; the integrations page shows the status of each. You connect your own account for each one — we walk you through it.`,
  },
];
